import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { FormUtilMasks } from '@app/features/utils/form-utils';

@Component({
  selector: 'app-input-text',
  templateUrl: './app-input-text.component.html',
  styleUrls: ['./app-input-text.component.scss']
})
export class AppInputTextComponent implements OnInit {

  ngOnInit() {

    if (this.inputType == InputType.date) {
      this.type = InputType.text;
      this.textMask = { mask: FormUtilMasks.dateMask };
      if (this.formControl.value) {
        this.value = this.formControl.value;
      }
    } else {
      this.type = this.inputType ? this.inputType : InputType.text;
    }
  }

  type: string = InputType.text;
  @Input() value: string = "";

  @ViewChild('inputView', { static: true }) inputView: ElementRef;
  @Input() inputType: string = InputType.text;
  @Input() label: string = "--";
  @Input() placeholder: string = "";
  @Input() icon: AppInputIcons;
  @Input() textMask: any = { mask: false }; //[textMask]="{ mask: utilForm1.cpfMaskfn() }"
  @Input() formControl: FormControl;
  @Input() showErrorLabel: boolean = true;
  @Input() customMessageError: string;

  @Output() onChange = new EventEmitter<string>();
  @Output() onFocus = new EventEmitter<string>();
  @Output() onBlur = new EventEmitter<string>(); // (blur)="utilForm1.cpfValidate($event.target.value)"

  clearInputText() {
    this.inputView.nativeElement.value = "";
  }

  onChangeEvent(value): void {
    this.onChange.emit(value);
  }

  onBlurEvent(): void {
    this.onBlur.emit(this.value);
  }

  onFocusEvent() {
    this.onFocus.emit(this.value);
  }

  get isInvalid() {
    return (this.formControl && this.formControl.errors && (this.formControl.dirty || this.formControl.touched));
  }

  static getHtmlElement(element: string) {
    return document.querySelector<HTMLElement>(element)!;
  }

}

export enum AppInputIcons {
  search = "icon-search",
  calendar = "icon-calendario"
}

export enum InputType {
  text = "text",
  number = "number",
  date = "date"
}
